import { createBrowserRouter } from 'react-router-dom'
import Login from '@/auth/pages/Login'
import AuthCallback from '@/auth/pages/AuthCallback'
import HomePage from '@/home/pages/Home'
import NotFound from './NotFound'
import { PrivateRoute } from './PrivateRoute'
import ErrorBoundary from './ErrorBoundary'
import PublicRecipe from '@/recipe/pages/PublicRecipe'

export const router = createBrowserRouter([
  {
    element: <ErrorBoundary />,
    children: [
      {
        element: <PrivateRoute />,
        children: [
          {
            path: '/',
            element: <HomePage />,
          },
          {
            path: '/recipes/:id',
            element: <HomePage />,
          },
        ],
      },
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/auth/callback',
        element: <AuthCallback />,
      },
      {
        path: '/recipe/:shareToken',
        element: <PublicRecipe />,
      },
    ],
  },
  {
    path: '/not-found',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
])
